

// import React, { useEffect, useState } from 'react';
// import Newtestmonial from './Newtestmonial';
// import Circle from './Circle';
// import Testmonial from './Testmonial';
// import Alldisplay from './Alldisplay';

// const StickyButtonNav = () => {
//   const [isSticky, setIsSticky] = useState(false);
//   const [activeIndex, setActiveIndex] = useState(0); // Track active button

//   useEffect(() => {
//     const handleScroll = () => {
//       setIsSticky(window.scrollY > 100);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const buttons = [
//     { label: 'Tec Talks', link: '/Newallcardspage' },
//     { label: 'Programs', link: '/Secondactiveprograms' },
//     { label: 'Career Program', link: '/Thirdactiveprogram' },
//   ];

//   const handleClick = (index) => {
//     setActiveIndex(index);
//   };

//   return (
//     <div style={{ height: 'auto' }}>
//       <div
//         style={{
//           position: isSticky ? 'fixed' : 'absolute',
//           top: isSticky ? 84 : '-404px',
//           left:'-0px',
//           zIndex: 999,
//           width: '100%',
//           background: 'white',
//           padding: '10px 0',
//           boxShadow: isSticky ? '0 2px 5px rgba(0,0,0,0.1)' : 'none',
//           transition: 'top 0.3s ease',
//         }}
//       >
//         <div
//           style={{
//             maxWidth: '1200px',
//             margin: '0 auto',
//             display: 'flex',
//             flexWrap: 'wrap',
//             justifyContent: 'center',
//             gap: '15px',
//             padding: '0 15px',
//           }}
//         >
//           {buttons.map((btn, index) => (
//             <a
//               key={index}
//               href={btn.link}
//               onClick={() => handleClick(index)}
//               style={{
//                 padding: '10px 25px',
//                 border: '2px solid ',
//                 borderRadius: '30px',
//                 textDecoration: 'none',
//                 background: activeIndex === index ? 'blue' : '#f7941d',
//                 color: 'white',
//                 fontWeight: activeIndex === index ? 'bold' : 'normal',
//                 fontSize: '16px',
//                 cursor: 'pointer',
//                 transition: 'all 0.3s ease',
//               }}
//             >
//               {btn.label}
//             </a>
//           ))}
//         </div>
//       </div>

//       <div style={{ marginTop: '314px' }}>
       
//       </div>
    
//     </div>
//   );
// };

// export default StickyButtonNav;


import React, { useEffect, useState } from 'react';

const StickyButtonNav = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 100);
    };
    
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', checkMobile);
    
    // Initial check
    checkMobile();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const buttons = [
    // { label: 'Tec Talks', link: '/Newallcardspage' },
    { label: 'Programs', link: '/Secondactiveprograms' },
    // { label: 'Career Program', link: '/Thirdactiveprogram' },
  ];

  const handleClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <div style={{ height: 'auto' }}>
      <div
        style={{
          position: isSticky ? 'fixed' : 'absolute',
          top: isSticky ? (isMobile ? '60px' : '84px') : '-404px',
          left: 0,
          right: 0,
          zIndex: 999,
          width: '100%',
          background: 'white',
          padding: isMobile ? '8px 0' : '10px 0',
          boxShadow: isSticky ? '0 2px 5px rgba(0,0,0,0.1)' : 'none',
          transition: 'top 0.3s ease',
        }}
      >
        <div
          style={{
            maxWidth: '1200px',
            margin: '0 auto',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: isMobile ? 'space-around' : 'center',
            gap: isMobile ? '8px' : '15px',
            padding: isMobile ? '0 8px' : '0 15px',
          }}
        >
          {buttons.map((btn, index) => (
            <a
              key={index}
              href={btn.link}
              onClick={() => handleClick(index)}
              style={{
                padding: isMobile ? '8px 12px' : '10px 25px',
                border: '2px solid',
                borderRadius: '30px',
                textDecoration: 'none',
                background: activeIndex === index ? 'blue' : '#f7941d',
                color: 'white',
                fontWeight: activeIndex === index ? 'bold' : 'normal',
                fontSize: isMobile ? '14px' : '16px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                whiteSpace: 'nowrap',
                textAlign: 'center',
                flex: isMobile ? '1 1 auto' : '0 0 auto',
                minWidth: isMobile ? '0' : 'none',
              }}
            >
              {btn.label}
            </a>
          ))}
        </div>
      </div>

      <div style={{ marginTop: isMobile ? '120px' : '314px' }} />
    </div>
  );
};

export default StickyButtonNav;